import React from "react";
import NavbarWhite from "../components/NavbarWhite";
import Footer from "../components/Footer";

const FailedAbbonamentoPage = () => {
  return (
    <div className="min-h-screen bg-white text-black font-[chivo]">
      <NavbarWhite />
      <div className="pt-32 text-center px-6 max-w-2xl mx-auto">
        <h1 className="text-4xl font-bold text-red-600 mb-6">Pagamento non riuscito ❌</h1>
        <p className="text-lg">Si è verificato un errore durante il processo di pagamento. Riprova oppure contattaci.</p>
      </div>
      <Footer />
    </div>
  );
};

export default FailedAbbonamentoPage;
